import {Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataService {

  isLoad: boolean = false;
  get second(): any {
    return this._second;
  }

  set second(value: any) {
    this._second = value;
  }
  get dataCMS(): any {
    return this._dataCMS;
  }

  set dataCMS(value: any) {
    this._dataCMS = value;
  }
  get optionSearch(): any {
    return this._optionSearch;
  }

  set optionSearch(value: any) {
    this._optionSearch = value;
  }
  get id(): boolean {
    return this._id;
  }

  set id(value: boolean) {
    this._id = value;
  }
  get isLoading(): boolean {
    return this._isLoading;
  }

  set isLoading(value: boolean) {
    this._isLoading = value;
  }
  get resetWallet(): boolean {
    return this._resetWallet;
  }

  set resetWallet(value: boolean) {
    this._resetWallet = value;
  }
  get markets(): Array<any> {
    return this._markets;
  }

  set markets(value: Array<any>) {
    this._markets = value;
  }

  get productReportPeriodicals(): Array<any> {
    return this._productReportPeriodicals;
  }

  set productReportPeriodicals(value: Array<any>) {
    this._productReportPeriodicals = value;
  }

  get investmentStrategies(): Array<any> {
    return this._investmentStrategies;
  }

  set investmentStrategies(value: Array<any>) {
    this._investmentStrategies = value;
  }

  get assetAllocations(): Array<any> {
    return this._assetAllocations;
  }

  set assetAllocations(value: Array<any>) {
    this._assetAllocations = value;
  }
  get formulas(): Array<any> {
    return this._formulas;
  }

  set formulas(value: Array<any>) {
    this._formulas = value;
  }
  get interestRate(): Array<any> {
    return this._interestRate;
  }

  set interestRate(value: Array<any>) {
    this._interestRate = value;
  }
  get paymentPeriodTypes(): Array<any> {
    return this._paymentPeriodTypes;
  }

  set paymentPeriodTypes(value: Array<any>) {
    this._paymentPeriodTypes = value;
  }
  
  get riskLevels(): Array<any> {
    return this._riskLevels;
  }

  set riskLevels(value: Array<any>) {
    this._riskLevels = value;
  }

  get provinces(): Array<any> {
    return this._provinces;
  }

  set provinces(value: Array<any>) {
    this._provinces = value;
  }

  get banks(): Array<any> {
    return this._banks;
  }

  set banks(value: Array<any>) {
    this._banks = value;
  }
  get fundTypes(): Array<any> {
    return this._fundTypes;
  }

  set fundTypes(value: Array<any>) {
    this._fundTypes = value;
  }
  get moneyTypes(): Array<any> {
    return this._moneyTypes;
  }

  set moneyTypes(value: Array<any>) {
    this._moneyTypes = value;
  }

  get listCountry(): Array<any> {
    return this._listCountry;
  }

  set listCountry(value: Array<any>) {
    this._listCountry = value;
  }

  get idTypes(): Array<any> {
    return this._idTypes;
  }
  
  set idTypes(value: Array<any>) {
    this._idTypes = value;
  }

  get socialTypes(): Array<any> {
    return this._socialTypes;
  }

  set socialTypes(value: Array<any>) {
    this._socialTypes = value;
  }
  
  get listLanguage(): Array<any> {
    return this._listLanguage;
  }

  set listLanguage(value: Array<any>) {
    this._listLanguage = value;
  }

  get daysOfWeek(): Array<any> {
    return this._daysOfWeek;
  }

  set daysOfWeek(value: Array<any>) {
    this._daysOfWeek = value;
  }

  get bondPeriodTypes(): Array<any> {
    return this._bondPeriodTypes;
  }

  set bondPeriodTypes(value: Array<any>) {
    this._bondPeriodTypes = value;
  }

  get bondRemainPeriods(): Array<any> {
    return this._bondRemainPeriods;
  }

  set bondRemainPeriods(value: Array<any>) {
    this._bondRemainPeriods = value;
  }

  get bondPeriodAdjustedTypes(): Array<any> {
    return this._bondPeriodAdjustedTypes;
  }

  set bondPeriodAdjustedTypes(value: Array<any>) {
    this._bondPeriodAdjustedTypes = value;
  }
  get supportInfo(): Array<any> {
    return this._supportInfo;
  }

  set supportInfo(value: Array<any>) {
    this._supportInfo = value;
  }
  get moneyTransferSyntax(): Array<any> {
    return this._moneyTransferSyntax;
  }

  set moneyTransferSyntax(value: Array<any>) {
    this._moneyTransferSyntax = value;
  }

  get relationalOperators(): Array<any> {
    return this._relationalOperators;
  }

  set relationalOperators(value: Array<any>) {
    this._relationalOperators = value;
  }
  get issuerTypes(): Array<any> {
    return this._issuerTypes;
  }

  set issuerTypes(value: Array<any>) {
    this._issuerTypes = value;
  }
  get agents(): Array<any> {
    return this._agents;
  }

  set agents(value: Array<any>) {
    this._agents = value;
  }
  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
  }

  get currentLang(): string {
    return this._currentLang;
  }

  set currentLang(value: string) {
    this._currentLang = value;
  }

  private _token: string = localStorage.getItem('key_local_token');

  private _currentLang: string = localStorage.getItem('key_local_language') ? localStorage.getItem('key_local_language') : 'default_language';

  private _listLanguage: Array<any> = [];

  private _listCountry: Array<any> = [];
  
  private _agents: Array<any> = [];

  private _issuerTypes: Array<any> = [];
  
  private _moneyTransferSyntax: Array<any> = [];

  private _relationalOperators: Array<any> = [];

  private _fundTypes: Array<any> = [];

  private _moneyTypes: Array<any> = [];

  private _banks: Array<any> = [];

  private _socialTypes: Array<any> = [];

  private _formulas: Array<any> = [];
  
  private _interestRate: Array<any> = [];

  private _provinces: Array<any> = [];

  private _idTypes: Array<any> = [];
  
  private _assetAllocations: Array<any> = [];

  private _investmentStrategies: Array<any> = [];

  private _productReportPeriodicals: Array<any> = [];
  
  private _paymentPeriodTypes: Array<any> = [];

  private _daysOfWeek: Array<any> = [];
  
  private _riskLevels: Array<any> = [];

  private _bondPeriodTypes: Array<any> = [];

  private _bondRemainPeriods: Array<any> = [];

  private _bondPeriodAdjustedTypes: Array<any> = [];

  private _supportInfo: Array<any> = [];

  private _markets: Array<any> = [];

  private _resetWallet :boolean = false;

  private _isLoading :boolean = true;

  private _id :any = null;

  private _second :any = null;

  private _optionSearch :any = [];

  private _dataCMS :any = localStorage.getItem('key_local_cms') ? JSON.parse(localStorage.getItem('key_local_cms')) : null;

  constructor(
  ) {
  }
  setData(data) {
    this.listCountry = data.countries || data.listCountry;
    this.issuerTypes = data.issuerTypes;
    this.idTypes = data.idTypes;
    this.banks = data.banks;
    this.agents = data.agents;
    this.formulas = data.formulas;
    this.moneyTransferSyntax = data.moneyTransferSyntax;
    this.interestRate = data.reinvestmentInterests || data.interestRate;
    this.paymentPeriodTypes = data.paymentPeriodTypes;
    this.bondPeriodTypes = data.bondPeriodTypes;
    this.bondPeriodAdjustedTypes = data.bondPeriodAdjustedTypes;
    this.bondRemainPeriods = data.bondRemainPeriods;
    this.supportInfo = data.supportInfo;
    this.fundTypes = data.fundTypes;
    this.provinces = data.provinces;
    this.relationalOperators = data.relationalOperators;
    this.riskLevels = data.riskLevels;
    this.socialTypes = data.socialTypes;
    this.assetAllocations = data.assetAllocations;
    this.daysOfWeek = data.daysOfWeek;
    if (this.daysOfWeek[0] && this.daysOfWeek[0].id != 0) {
      this.daysOfWeek.unshift({
        id: 0,
        name: 'Hằng ngày'
      })   
    }
  }
  getFull() {
    return {
      listCountry : this.listCountry,
      countries : this.listCountry,
      issuerTypes: this.issuerTypes,
      banks: this.banks,
      formulas: this.formulas,
      interestRate: this.interestRate,
      paymentPeriodTypes: Object.assign([],this.paymentPeriodTypes) ,
      fundTypes: this.fundTypes,
      riskLevels: this.riskLevels,
      socialTypes: this.socialTypes,
      assetAllocations: this.assetAllocations,
      daysOfWeek: this.daysOfWeek,
      supportInfo: this.supportInfo,
      bondPeriodAdjustedTypes: this.bondPeriodAdjustedTypes,
      bondPeriodTypes: this.bondPeriodTypes,
      bondRemainPeriods: this.bondRemainPeriods,
      provinces: this.provinces,
      relationalOperators: this.relationalOperators,
      agents: this.agents,
      idTypes: this.idTypes,
      moneyTransferSyntax: this.moneyTransferSyntax
    }
  }
  subData(http: any) {
    return new Promise((resolve, reject) => {
      let interval = setInterval(() => {
        if (this.listCountry && this.listCountry.length > 0) {
          clearInterval(interval);
          resolve(this.getFull());
        } else if (!this.isLoad) {
          return this.getDataCommon(http);
        }
      }, 200)
    })
  }
  getVariableData(http: any,dataType) {
   
    return new Promise<any>((resolve, reject) => {
      let data = JSON.parse(sessionStorage.getItem('key_local_common_data'));
      if (!data || !data[dataType]) {
        this.getDataCommon(http)
          .then((res: any) => {
            if (res) {
              resolve(res[dataType])
            } else {
              resolve(false)
            }
          })
      } else resolve(data[dataType])
    })
  }

  public getDataCommon(http: any) {
    this.isLoad = true;
    return new Promise<any>((resolve, reject) => {
      http.get('api_common')
        .subscribe(res => {
          this.isLoad = false;
          if (res.status === 'success_code') {
            sessionStorage.setItem('key_local_common_data',JSON.stringify(res.data));
            this.setData(res.data);
            resolve(res.data)
          }
        })
    })
  }
}
